import ApiService from "@/services/api.service";

class AdhesionError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const buildAdhesionError = (error, fallbackMessage) => {
  const status = error && error.response ? error.response.status : null;
  const data = error && error.response ? error.response.data : null;
  const message =
    (data && (data.detail || data.message || data.error)) ||
    error.message ||
    fallbackMessage;
  return new AdhesionError(status, message);
};

const AdhesionService = {
  createOrder: async function(payload) {
    try {
      const response = await ApiService.post("/adhesion/commande", payload);
      return response;
    } catch (error) {
      throw buildAdhesionError(error, "Impossible de creer la commande.");
    }
  },

  addMembership: async function(payload) {
    try {
      const response = await ApiService.post("/adhesion/ajouter", payload);
      return response;
    } catch (error) {
      throw buildAdhesionError(error, "Impossible de creer l'adhesion.");
    }
  },

  listMine: async function() {
    try {
      const response = await ApiService.get("/adhesion/miennes");
      return response;
    } catch (error) {
      throw buildAdhesionError(error, "Impossible de recuperer vos adhesions.");
    }
  },

  shareFamily: async function(payload) {
    try {
      const response = await ApiService.post("/adhesion/partage-famille", payload);
      return response;
    } catch (error) {
      throw buildAdhesionError(error, "Impossible de partager l'adhesion.");
    }
  },

  checkUserAdhesion: async function() {
    try {
      const response = await ApiService.get("/adhesion/check");
      return response;
    }
    catch (error) {
      throw buildAdhesionError(error, "Impossible de vérifier l'adhésion de l'utilisateur.");
    }
  },

  useDay: async function(id) {
    try {
      const response = await ApiService.get(`/adhesion/adhesion-journee/utiliser/${id}`);
      return response;
    } catch (error) {
      throw buildAdhesionError(error, "Impossible d'utiliser l'adhesion journee.");
    }
  },

  checkValid: async function(id) {
    try {
      const response = await ApiService.get(`/adhesion/test-valide/${id}`);
      return response;
    } catch (error) {
      throw buildAdhesionError(error, "Impossible de verifier l'adhesion.");
    }
  },

  remove: async function(id) {
    try {
      const response = await ApiService.delete(`/adhesion/supprimer/${id}`);
      return response;
    } catch (error) {
      throw buildAdhesionError(error, "Impossible de supprimer l'adhesion.");
    }
  }
};

export default AdhesionService;

export { AdhesionService, AdhesionError };
